import React, { useRef, useState, useEffect } from 'react';

export const GREEN = '#0D3B2E';
export const GREEN2 = '#1B5E20';

export const lbl = { fontSize: 11, color: '#666', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 3, display: 'block' };
export const inp = { width: '100%', padding: '7px 9px', border: '1px solid #ccc', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' };

export function SignaturePad({ label, onChange }) {
  const canvasRef = useRef(null);
  const [mode, setMode] = useState('draw');
  const [typed, setTyped] = useState('');
  const drawing = useRef(false);
  const last = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const c = canvasRef.current;
    if (!c) return;
    const ctx = c.getContext('2d');
    ctx.strokeStyle = GREEN; ctx.lineWidth = 2; ctx.lineCap = 'round';
  }, [mode]);

  function pos(e) {
    const r = canvasRef.current.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - r.left, y: t.clientY - r.top };
  }
  const start = (e) => { e.preventDefault(); drawing.current = true; last.current = pos(e); };
  const move = (e) => {
    if (!drawing.current) return; e.preventDefault();
    const ctx = canvasRef.current.getContext('2d'); const p = pos(e);
    ctx.beginPath(); ctx.moveTo(last.current.x, last.current.y); ctx.lineTo(p.x, p.y); ctx.stroke();
    last.current = p;
  };
  const end = () => { if (!drawing.current) return; drawing.current = false; onChange(canvasRef.current.toDataURL()); };
  const clear = () => {
    const c = canvasRef.current; c.getContext('2d').clearRect(0, 0, c.width, c.height);
    setTyped(''); onChange('');
  };

  const tab = (active) => ({ padding: '4px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer', borderRadius: 6,
    border: '1px solid ' + (active ? GREEN : '#ccc'), background: active ? GREEN : '#fff', color: active ? '#fff' : '#555' });

  return (
    <div style={{ marginTop: 4 }}>
      <div style={{ display: 'flex', gap: 8, marginBottom: 6 }}>
        <button type="button" onClick={() => { setMode('draw'); clear(); }} style={tab(mode === 'draw')}>Draw</button>
        <button type="button" onClick={() => { setMode('type'); clear(); }} style={tab(mode === 'type')}>Type</button>
        <button type="button" onClick={clear} style={{ ...tab(false), marginLeft: 'auto' }}>Clear</button>
      </div>
      {mode === 'draw' ? (
        <canvas ref={canvasRef} width={420} height={90}
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end}
          style={{ width: '100%', maxWidth: 420, height: 90, border: '1px solid #bbb', borderRadius: 6, background: '#fff', touchAction: 'none', cursor: 'crosshair' }} />
      ) : (
        <input value={typed} onChange={(e) => { setTyped(e.target.value); onChange('TYPED:' + e.target.value); }}
          placeholder="Type full name as signature"
          style={{ width: '100%', maxWidth: 420, fontFamily: "'Brush Script MT', cursive", fontSize: 26, color: GREEN, padding: '6px 10px', border: '1px solid #bbb', borderRadius: 6 }} />
      )}
      <div style={{ fontSize: 11, color: '#888', marginTop: 3 }}>{label}</div>
    </div>
  );
}

export function ContractShell({ title, children, onGenerate, saving, savedDoc, buttonLabel }) {
  const label = buttonLabel || 'Generate Signed PDF →';
  return (
    <div className="contract-shell" style={{ background: '#fff', fontFamily: 'system-ui, sans-serif', color: '#222' }}>
      <h2 style={{ textAlign: 'center', margin: '0 0 4px', color: GREEN, letterSpacing: 1 }}>{title}</h2>
      <div style={{ borderBottom: '2px solid ' + GREEN, marginBottom: 16 }} />
      {children}
      <button type="button" disabled={saving} onClick={onGenerate}
        style={{ marginTop: 24, width: '100%', padding: 14, background: saving ? '#888' : GREEN, color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: saving ? 'default' : 'pointer' }}>
        {saving ? 'Generating…' : label}
      </button>
      {savedDoc && (
        <div style={{ marginTop: 14, padding: 14, background: '#f0f7f0', border: '1px solid ' + GREEN2, borderRadius: 8, textAlign: 'center' }}>
          <div style={{ fontWeight: 700, color: GREEN2, marginBottom: 6 }}>✓ Signed &amp; attached to the job</div>
          <a href={savedDoc.url} target="_blank" rel="noreferrer" style={{ color: GREEN, fontWeight: 600 }}>View / download the signed PDF</a>
        </div>
      )}
    </div>
  );
}
